import "@babel/polyfill";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'
import axiosWrap from './components/axiosWrap'
import ApiCall from './components/apiCall'
import Toasted from 'vue-toasted'
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueLazyload from 'vue-lazyload'
import Dict from './components/dict'

import './assets/fonts/iconfont.css'
import './assets/style/style.less'

Vue.use(Toasted);
Vue.use(VueAxios, axiosWrap);
Vue.use(VueTour);
Vue.use(preview,{bgOpacity: .6})
Vue.use(VueLazyload, {
  lazyComponent: true,
  preLoad: 1.2,
  error: 'img/none-img.png',
  loading: 'img/loading-img.png',
  adapter: {
    loaded({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
      if (el.classList.value.indexOf('img-wrapp') > -1) {
        el.classList.add('lazyload-success');
        if (!naturalWidth) {
          let img = new Image();
          img.src = src;
          img.onload = function () {
            if (img.height > img.width) {
              el.classList.add('bg-y-100')
            }
          }
        } else if (naturalHeight > naturalWidth) {
          el.classList.add('bg-y-100')
        }
      }
    },
  }
});
Vue.prototype.$apiCall = ApiCall;  //Vue.$apiCall(api,params,callback)
const moment = require('moment');
Vue.prototype.$moment = moment;
Vue.prototype.$dict = Dict;

Vue.config.productionTip = false

//路由守卫
router.beforeEach((to, from, next) => {
	if (process.env.NODE_ENV == 'production') {//生产环境验证版本
		Vue.axios.get('/version.json?_=' + process.env.VERSION, {baseURL:'//'})
		.then(r => {
			if (process.env.VERSION != r.data.version) {
				next(false);
				document.getElementById("modalVerChange").style.display = "block";
			}else{
				next(true);
			}
		})
// 		axios.get('version.json?_=' + process.env.VERSION, {baseURL:'//'})
// 			.then(function (response) {
// 				console.log(response)
// 				if (process.env.VERSION != response.data.version) {
// 					next(false);
// 					document.getElementById("modalVerChange").style.display = "block";
// 					console.log(2)
// 				}else{
// 					next(true);
// 					console.log(3)
// 				}
// 			})
}else{
		next(true);
	}
});

//路由守卫
// router.beforeEach((to, from, next) => {
// 	if (process.env.NODE_ENV == 'production') {//生产环境验证版本
// 		$.getJSON('/offer/version.json?_=' + process.env.VERSION, r => {
// 			console.log(r)
// 			if (process.env.VERSION != r.version) {
// 				next(true);
// 			} else {
// 				next(true);
// 			}
// 		});
// 	} else {
// 		next(true);
// 	}
// });
//路由后置
router.afterEach((to, from) => {
  if (typeof _hmt == 'object'){
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
})
new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
